export default __webpack_public_path__ + "static/media/show_wine.8103bf06.svg";